import React from 'react';
import { Form, Input, Typography, Checkbox, Button } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
// Utils
import { EMPTY_PRODUCT } from 'helpers/customCampaignConstants';
// Style
import styles from './ProductsList.module.scss';

const { Text } = Typography;

const ProductsList = (): JSX.Element => {
  return (
    <>
      <div className={styles.productsHeader}>
        <h4 className={styles.subSectionTitle}>Products</h4>
        <Text type="secondary" className={styles.subSectionDescription}>
          Optional products sent to talent as part of the campaign.
        </Text>
      </div>

      <Form.List name="products">
        {(fields, { add, remove }) => (
          <>
            {fields.map((field) => (
              <div key={field.key} className={styles.productCard}>
                <div className={styles.productCardHeader}>
                  <Text strong>{`Product ${field.name + 1}`}</Text>
                  <Button
                    danger
                    type="text"
                    icon={<DeleteOutlined />}
                    onClick={() => remove(field.name)}
                  >
                    Remove
                  </Button>
                </div>

                <Form.Item
                  name={[field.name, 'name']}
                  label={<Text>Product Name</Text>}
                >
                  <Input placeholder="Adi2000 Sneakers" />
                </Form.Item>

                <div className={styles.row}>
                  <Form.Item
                    name={[field.name, 'cost']}
                    label={<Text>Product Value</Text>}
                  >
                    <Input
                      type="number"
                      min={0}
                      placeholder="0"
                      aria-label="Product Value"
                    />
                  </Form.Item>

                  <Form.Item
                    name={[field.name, 'qty']}
                    label={<Text>Quantity</Text>}
                  >
                    <Input
                      type="number"
                      min={1}
                      placeholder="1"
                      aria-label="Product Quantity"
                    />
                  </Form.Item>
                </div>

                <Form.Item
                  name={[field.name, 'description']}
                  label={<Text>Details</Text>}
                >
                  <Input placeholder="Our new top of the line sneakers launching in May 2026." />
                </Form.Item>

                <Form.Item
                  name={[field.name, 'shipping']}
                  valuePropName="checked"
                >
                  <Checkbox>Requires shipping</Checkbox>
                </Form.Item>
              </div>
            ))}

            <Button
              type="dashed"
              icon={<PlusOutlined />}
              className={styles.addProductButton}
              onClick={() => add({ ...EMPTY_PRODUCT })}
            >
              Add Product
            </Button>
          </>
        )}
      </Form.List>
    </>
  );
};

export default ProductsList;
